import { graphql } from "gatsby";
import React from "react";
import "./pageFooterText.scss";

interface Props {
  headline: string;
  text: string;
  table: {
    name: string;
    position: string;
  }[];
}

const PageFooterText: React.FC<Props> = (props) => {
  return (
    <div className="page-footer-text">
      <h5 className="page-footer-text__title">{props.headline}</h5>
      <div className="page-footer-text__content">
        {!!props.table && (
          <table>
            <tbody>
              {props.table.map((item, key) => (
                <tr key={key}>
                  <td>{item.name}</td>
                  <td>{item.position}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default PageFooterText;

export const query = graphql`
  fragment PageFooterTextBlock on WpAcfPagefootertextBlock {
    AcfPageFooterTextBlock {
      headline
      table {
        name
        position
      }
    }
  }
`;
